export default {
  "Account": {
    en: "Account",
    ja: "アカウント"
  },
  "Personal data": {
    en: "Personal data",
    ja: "個人データ"
  },
  "Security settings": {
    en: "Security settings",
    ja: "セキュリティ設定"
  },
  "Payment information": {
    en: "Payment information",
    ja: "支払情報"
  },
  "Logout": {
    en: "Logout",
    ja: "ログアウト"
  }
}